import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { inject } from '@angular/core'
import { USER_ROLES } from '../constants/auth'

export const authRedirectGuard: CanActivateFn = () => {
  const isLoggedIn = inject(AuthService).isLoggedIn()

  if (isLoggedIn) {
    return inject(Router).createUrlTree(['/', ''])
  }

  return true
}

export const loggedInGuard: CanActivateFn = () => {
  const isLoggedIn = inject(AuthService).isLoggedIn()

  if (!isLoggedIn) {
    return inject(Router).createUrlTree(['/auth', 'login'])
  }

  return true
}

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const session = authService.getSessionFromLS()
  if (session) {
    const isAuthorized = [
      USER_ROLES.MASTER,
      USER_ROLES.ADMIN,
      USER_ROLES.COMPLIANCE_OFFICER,
    ].includes(session.user.role)
    if (isAuthorized) {
      return true
    }
  }
  return inject(Router).createUrlTree(['/', ''])
}

export const requisitionCartGuard: CanActivateFn = (_route, state) => {
  const session = inject(AuthService).getSessionFromLS()
  if (!session) {
    return inject(Router).createUrlTree(['/auth', 'login'], {
      queryParams: { returnUrl: state.url },
    })
  }
  if (
    session &&
    [USER_ROLES.ADMIN, USER_ROLES.COMPLIANCE_OFFICER].includes(
      session.user.role,
    )
  )
    return true
  return inject(Router).createUrlTree(['/', ''])
}

export const masterGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const session = authService.getSessionFromLS()

  if (session) {
    const isMaster = session.user.role === USER_ROLES.MASTER
    if (isMaster) {
      return true
    }
  }
  return inject(Router).createUrlTree(['/', ''])
}
